import React from 'react';
import { Box, Stack } from '@mui/material';
import { Layout } from 'src/components/layout-wrapper/Layout';
import { useViewport } from 'src/lib/utils';
import { useSSOAuth } from './useSSOAuth';

const SSOAuth: React.FC = () => {
  const { loading, error } = useSSOAuth();
  const { isMobile } = useViewport();

  if (loading) {
    return (
      <Layout showLighterColors module={'signup'}>
        <Stack sx={{ paddingBlock: isMobile ? '36px' : '58px' }} gap={'20px'}>
          <Stack alignItems="center" gap={isMobile ? '16px' : '64px'}>
            <Box
              sx={{ fontSize: isMobile ? '24px' : '32px', fontWeight: 'bold' }}>
              Authenticating...
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
              }}>
              <div style={styles.spinner}></div>
              <Box sx={{ color: '#666', textAlign: 'center' }}>
                Please wait while we log you in.
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout showLighterColors module={'signup'}>
        <Stack sx={{ paddingBlock: isMobile ? '36px' : '58px' }} gap={'20px'}>
          <Stack alignItems="center" gap={isMobile ? '16px' : '64px'}>
            <Box
              sx={{ fontSize: isMobile ? '24px' : '32px', fontWeight: 'bold' }}>
              Authentication Failed
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
              }}>
              <Box sx={{ fontSize: '48px' }}>⚠️</Box>
              <Box
                sx={{
                  color: '#d32f2f',
                  textAlign: 'center',
                  maxWidth: '400px',
                }}>
                {error}
              </Box>
              <Box sx={{ color: '#666', textAlign: 'center' }}>
                Redirecting to login page...
              </Box>
            </Box>
          </Stack>
        </Stack>
      </Layout>
    );
  }

  return null;
};

const styles = {
  spinner: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #007bff',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 2s linear infinite',
    margin: '0 auto',
  },
};

const spinnerCSS = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

if (
  typeof document !== 'undefined' &&
  !document.querySelector('#sso-spinner-styles')
) {
  const style = document.createElement('style');
  style.id = 'sso-spinner-styles';
  style.textContent = spinnerCSS;
  document.head.appendChild(style);
}

export default SSOAuth;
